import React from 'react';
import Icon from 'ui/Icon';

const Header = props => {
  const { title } = props;
  return (
    <>
      <header className="px-32 py-16">
        <h1 className="ff-ss fz-24 fw-b mb-8 mt-8 lh-1">
          <Icon name="link" />
          <span className="text-wrap mr-12 ml-12">{title}</span>
        </h1>
      </header>
    </>
  );
};

export default Header;
